"use client";

import React from "react";
import CustomGsapHeaderAnimate from "../utils/CustomGsapHeaderAnimate";
import ProjectDetailSlider from "../productCategoryOne/ProjectDetailSlider";
import ImgAnimateLeftToRight from "../utils/ImgAnimateLeftToRight";
import GuideSection from "../guide/GuideSection";
type Props = {
  title: string;
};
const MilletsSection1 = ({ title }: Props) => {
  return (
    // <div style={{ paddingLeft: "100px", paddingRight: "100px" }}>
    <div className="container">
      <ProjectDetailSlider />
      <div className="rv-project-details__txt">
        <div className="left">
          <CustomGsapHeaderAnimate>
            <h3 className="rv-service-details__title">{title}</h3>
          </CustomGsapHeaderAnimate>

          <p className="rv-service-details__descr">
            Little millet (<em>Panicum sumatrense</em>) is a small-seeded grain
            from the millet family, known for its high nutritional value and
            health benefits. It is rich in fiber, protein, iron, and calcium,
            making it a great alternative to rice and wheat.
          </p>

          <p className="rv-service-details__descr">
            Being gluten-free and easy to digest, little millet is ideal for
            people with gluten intolerance and digestive issues. It is commonly
            used in various dishes like porridge, upma, dosa, and even baked
            goods, making it a versatile and healthy food choice.
          </p>
        </div>

        <div className="rv-project-details__infos">
          <div className="rv-project-details-info">
            <h5 className="rv-project-details-info__name">Scientific Name:</h5>
            <span className="rv-project-details-info__value">
              Panicum sumatrense
            </span>
          </div>

          <div className="rv-project-details-info">
            <h5 className="rv-project-details-info__name">
              Nutritional Value:
            </h5>
            <span className="rv-project-details-info__value">
              High in fiber, protein, iron, and calcium
            </span>
          </div>

          <div className="rv-project-details-info">
            <h5 className="rv-project-details-info__name">Uses:</h5>
            <span className="rv-project-details-info__value">
              Used in upma, dosa, idli,
            </span>
          </div>
        </div>
      </div>

      <div className="rv-project-details__features">
        <div className="row g-30 align-items-center">
          <div className="col-xl-5 col-lg-6">
            <div className="rv-project-details__features-list">
              <CustomGsapHeaderAnimate>
                <h5>Why Choose Little Millet?</h5>
              </CustomGsapHeaderAnimate>
              <ul>
                <li>
                  <strong>Nutrient-Rich:</strong> Packed with fiber, protein,
                  iron, and calcium.
                </li>
                <li>
                  <strong>Gluten-Free:</strong> Ideal for those with gluten
                  intolerance.
                </li>
                <li>
                  <strong>Diabetes-Friendly:</strong> Helps regulate blood sugar
                  levels.
                </li>
                <li>
                  <strong>Easy to Digest:</strong> Light on the stomach and
                  promotes gut health.
                </li>
                <li>
                  <strong>Sustainable & Hardy:</strong> Grows in dry conditions
                  with minimal water.
                </li>
                <li>
                  <strong>Versatile in Cooking:</strong> Perfect for porridge,
                  upma, dosa, and more.
                </li>
              </ul>
            </div>
          </div>
          <div className="col-xl-7 col-lg-6">
            <div className="rv-project-details__features-img">
              <ImgAnimateLeftToRight
                src="assets/hindustanpurefoods/banner/millet-banner-2.webp"
                alt="image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MilletsSection1;
